<template>
  <div class="strategyRecord ashComWrap">
    <div class="comTitle">
      <h4>策略修改记录</h4>
    </div>
    <div class="comContentBox">
      <ul>
        <template v-if="strategyId">
          <li v-for="(v, i) in listData" :key="i">
            <el-descriptions
              :column="1"
              size="mini"
              style="width: 96%; margin: 5px auto"
            >
              <el-descriptions-item label="修改时间">{{
                v.time
              }}</el-descriptions-item>
              <el-descriptions-item label="修改人">{{
                v.user
              }}</el-descriptions-item>
              <el-descriptions-item label="策略名称">{{
                v.name
              }}</el-descriptions-item>
            </el-descriptions>
          </li>
        </template>
        <el-empty
          class="comContentBox"
          v-else
          description="暂无信息"
        ></el-empty>
      </ul>
      <el-pagination
        small
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :pager-count="5"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="page.size"
        layout="prev, pager, next, jumper"
        :total="page.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
export default {
  props: {
    strategyId: {
      type: String,
      default: "",
    },
  },
  watch: {
    strategyId: {
      handler(newvalue, oldvalue) {
        if (this.strategyId) {
          this.getListData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      listData: [],
      page: {
        total: null,
        size: 10,
      },
      currentPage: 1,
    };
  },
  methods: {
    async getListData() {
      this.listData = [];
      let res = await api.ACRStrategyRecordList({
        strategyId: this.strategyId,
        pageSize: this.page.size,
        page: this.currentPage - 1,
      });
      if (res && res.data.code == 200) {
        this.page.total = res.data.data.totalElements;
        let data = res.data.data.data;
        this.listData = Array.from(data).map((item) => ({
          name: item.name,
          time: dateFtt("yyyy-MM-dd hh:mm:ss", new Date(item.createdTime)),
          user: item.createdInfo.name ? item.createdInfo.name : "-",
        }));
      }
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getListData();
    },
  },
};
</script>

<style lang="scss" scoped>
.strategyRecord {
  width: 100%;
  height: calc(100% - 312px);
  margin-top: 12px;
  ul {
    width: 90%;
    height: calc(100% - 45px);
    margin: 0 auto 12px;
    overflow: auto;
    li {
      border-bottom: 1px solid #ebeef5;
    }
  }
}
</style>
